import { store } from 'store'
import {
  filterSearchInput,
  filterSearchOptions,
  filterSearchInput1,
  filterSearchOptions2,
  filterSearchOptions3,
  filterSearchOptions4,
  filterSearchSourcingInput1,
  filterSearchSourcingOptions2,
  filterSearchSourcingOptions3,
  filterSearchSourcingOptions4,
  filterSourcingSupplierInput1,
  filterSourcingSupplierOptions2,
  filterSourcingSupplierOptions3,
  filterSourcingSupplierOptions4,
  filterSearchSourcingOptions5,
  filterSourcingSupplierOptionsEventType,
  filterDateFrom,
  filterDateTo,
  filterPage,
  filterPageAllEvent,
  filterStatusSourcingProjects,
  searchEventListSearch,
  searchEventListAllStatus,
  searchEventListAllEventType,
  searchEventListSealStatus,
  searchEventListAllAward,
  searchEventListAllUser,
} from '../../../store/actions'
const clearFilter = () => {
  store.dispatch(filterSearchInput(''))
  store.dispatch(filterSearchOptions(''))
  store.dispatch(filterSearchInput1(''))
  store.dispatch(filterSearchOptions2(''))
  store.dispatch(filterSearchOptions3(''))
  store.dispatch(filterSearchOptions4(''))
  store.dispatch(filterSearchSourcingInput1())
  store.dispatch(filterSearchSourcingOptions2())
  store.dispatch(filterSearchSourcingOptions3())
  store.dispatch(filterSearchSourcingOptions4())
  store.dispatch(filterSourcingSupplierInput1())
  store.dispatch(filterSourcingSupplierOptions2())
  store.dispatch(filterSourcingSupplierOptions3())
  store.dispatch(filterSourcingSupplierOptions4())
  store.dispatch(filterSearchSourcingOptions5())
  store.dispatch(filterSourcingSupplierOptionsEventType())
  store.dispatch(filterDateFrom())
  store.dispatch(filterDateTo())
  store.dispatch(filterPage())
  store.dispatch(filterPageAllEvent())
  store.dispatch(filterStatusSourcingProjects())
  store.dispatch(searchEventListSearch())
  store.dispatch(searchEventListAllStatus())
  store.dispatch(searchEventListAllEventType())
  store.dispatch(searchEventListSealStatus())
  store.dispatch(searchEventListAllAward())
  store.dispatch(searchEventListAllUser())
}
export default clearFilter
